module.exports = __webpack_public_path__ + "img/close.5f1d2fa5.svg";